export const GRAY_TEAL = "#a6b3ba";
